import React, {useState, useContext, createContext, FC, PropsWithChildren, useEffect} from 'react'

interface UserContextUsuario {
  idUsuario: number
  setIdUsuario: (idUsuario: number) => void
}
interface UserContextBanco {
  idBanco: number
  setIdBanco: (idBanco: number) => void
}
interface UserContextRol {
  idRol: string
  setIdRol: (idRol: string) => void
}
interface UserContextWorkCenter {
  idWorkCenter: string
  setIdWorkCenter: (idWorkCenter: string) => void
}
interface UserContextPreguntas {
  idPreguntas: number
  setIdPreguntas: (idPreguntas: number) => void
}
interface UserContextCanales {
  idCanales: number
  setIdCanales: (idCanales: number) => void
}
interface UserContextPais {
  idPais: string
  setIdPais: (idPais: string) => void
}

// create context

const userContextUsuario = createContext<UserContextUsuario>({
  idUsuario: 0,
  setIdUsuario: () => {},
})
const userContextBanco = createContext<UserContextBanco>({
  idBanco: 0,
  setIdBanco: () => {},
})
const userContextRol = createContext<UserContextRol>({
  idRol: '',
  setIdRol: () => {},
})
const userContextWorkCenter = createContext<UserContextWorkCenter>({
  idWorkCenter: '',
  setIdWorkCenter: () => {},
})
const userContextPreguntas = createContext<UserContextPreguntas>({
  idPreguntas: 0,
  setIdPreguntas: () => {},
})
const userContextCanales = createContext<UserContextCanales>({
  idCanales: 0,
  setIdCanales: () => {},
})
const userContextPais = createContext<UserContextPais>({
  idPais: '',
  setIdPais: () => {},
})

// use context

export function useContextUsuario() {
  return useContext(userContextUsuario)
}
export function useContextBanco() {
  return useContext(userContextBanco)
}
export function useContextRol() {
  return useContext(userContextRol)
}
export function useContextWorkCenter() {
  return useContext(userContextWorkCenter)
}
export function useContextPreguntas() {
  return useContext(userContextPreguntas)
}
export function useContextCanales() {
  return useContext(userContextCanales)
}
export function useContextPais() {
  return useContext(userContextPais)
}

export const DataContextId: FC<PropsWithChildren<{}>> = (props) => {
  const [idUsuario, setIdUsuario] = useState<number>(0)
  const [idBanco, setIdBanco] = useState<number>(0)
  const [idRol, setIdRol] = useState<string>('')
  const [idWorkCenter, setIdWorkCenter] = useState<string>('')
  const [idPreguntas, setIdPreguntas] = useState<number>(0)
  const [idCanales, setIdCanales] = useState<number>(0)
  const [idPais, setIdPais] = useState<string>('')

  useEffect(() => {
    const storedDataUsuario = localStorage.getItem('idUsuario')
    if (storedDataUsuario) {
      const parsedData = parseInt(storedDataUsuario)
      setIdUsuario(parsedData)
    }
    const storedDataBanco = localStorage.getItem('idBanco')
    if (storedDataBanco) {
      const parsedData = parseInt(storedDataBanco)
      setIdBanco(parsedData)
    }
    const storedDataRol = localStorage.getItem('idRol')
    if (storedDataRol) {
      setIdRol(storedDataRol)
    }
    const storedDataWorkCenter = localStorage.getItem('idWorkCenter')
    if (storedDataWorkCenter) {
      setIdWorkCenter(storedDataWorkCenter)
    }
    const storedDataPreguntas = localStorage.getItem('idPreguntas')
    if (storedDataPreguntas) {
      const parsedData = parseInt(storedDataPreguntas)
      setIdPreguntas(parsedData)
    }
    const storedDataCanal = localStorage.getItem('idCanal')
    if (storedDataCanal) {
      const parsedData = parseInt(storedDataCanal)
      setIdCanales(parsedData)
    }
    const storedDataPais = localStorage.getItem('idPais')
    if (storedDataPais) {
      setIdPais(storedDataPais)
    }
  }, [])

  return (
    <userContextUsuario.Provider value={{idUsuario, setIdUsuario}}>
      <userContextBanco.Provider value={{idBanco, setIdBanco}}>
        <userContextRol.Provider value={{idRol, setIdRol}}>
          <userContextWorkCenter.Provider value={{idWorkCenter, setIdWorkCenter}}>
            <userContextPreguntas.Provider value={{idPreguntas, setIdPreguntas}}>
              <userContextCanales.Provider value={{idCanales, setIdCanales}}>
                <userContextPais.Provider value={{idPais, setIdPais}}>
                  {props.children}
                </userContextPais.Provider>
              </userContextCanales.Provider>
            </userContextPreguntas.Provider>
          </userContextWorkCenter.Provider>
        </userContextRol.Provider>
      </userContextBanco.Provider>
    </userContextUsuario.Provider>
  )
}
